<template>
  <v-card outlined>
    <v-card-title>
      Sales vs. Costs Chart
    </v-card-title>
    <v-divider class="mx-4"/>
    <v-card-text>
      <im-horizontal-bar-chart :chart-data="chart_data" :options="chart_options" :height="250"/>
    </v-card-text>
  </v-card>
</template>

<script>

  export default {

    components: {
      'im-horizontal-bar-chart': () => import('@/components/Statistics/HorizontalBarChart')
    },

    props: {
      sales: Object,
      rooms: Array
    },

    computed: {

      chart_data() {
        return {
          labels: this.getChartLabels(),
          datasets: [
            {
              label: 'Costs',
              data: this.getCostsData(),
              borderColor: '#0080ff',
              backgroundColor: '#0080ff'
            },
            {
              label: 'Sales',
              data: this.getSalesData(),
              borderColor: '#00ff80',
              backgroundColor: '#00ff80'
            }
          ]
        }
      },

      chart_options() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          fill: false,
          legend: false,
          tooltips: {
            mode: 'index'
          },
          scales: {
            xAxes: [{
              stacked: true
            }],
            yAxes: [{
              stacked: true
            }]
          }

        }
      }

    },

    methods: {
      getChartLabels() {
        let labels = [];
        if (!this.sales.datasets.rooms)
          return labels;

        for (let room in this.sales.datasets.rooms) {
          if (Object.prototype.hasOwnProperty.call(this.sales.datasets.rooms, room))
            labels.push(this.rooms[room].text);
        }

        return labels;
      },

      getSalesData() {
        let data = [];
        if (!this.sales.datasets.rooms)
          return data;

        for (let room in this.sales.datasets.rooms) {
          if (Object.prototype.hasOwnProperty.call(this.sales.datasets.rooms, room))
            data.push(Math.abs(_.sum(this.sales.datasets.rooms[room].sales)));
        }

        return data;
      },

      getCostsData() {
        let data = [];
        if (!this.sales.datasets.rooms)
          return data;

        for (let room in this.sales.datasets.rooms) {
          if (Object.prototype.hasOwnProperty.call(this.sales.datasets.rooms, room))
            data.push(-1 * Math.abs(_.sum(this.sales.datasets.rooms[room].costs)));
        }

        return data;
      }
    }


  }
</script>